import { render, staticRenderFns } from "./DropdownIcon.vue?vue&type=template&id=996f07da"
import script from "./DropdownIcon.vue?vue&type=script&lang=ts"
export * from "./DropdownIcon.vue?vue&type=script&lang=ts"
import style0 from "./DropdownIcon.vue?vue&type=style&index=0&id=996f07da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports